module.exports = __webpack_public_path__ + "static/img/yw01.33bb234.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yw01.png
// module id = SBzN
// module chunks = 0